<template>
  <div style="width:100%;float:left;background-color: #fff;">
    <div class="reportHeader col-12 float-left">
      <div class="col-4 float-left text-center">
        <label style="width:100%;float:left;">Updated Acct Name</label>
        <v-select v-if="repOptions" v-model="accountSelected" :options="repOptions" label="name" placeholder="Select Acct"></v-select>
      </div>
      <div class="col-4 float-left text-center">
        Imperial
      </div>
      <div class="col-4 float-left text-center">
        Year/Month
      </div>
    </div>
    <spacer />
    <div style="width:100%;float:left;" v-if="!loading && data">
      <div class="twenty left">
        <label style="width:100%;float:left;text-align: center;">Top Sale Benchmarks</label>
        <div class="reportCard">
          <label class="labelHeader">YTD Sold</label>
          <label class="value">${{getNumFormat(data.ytd[0].total_sales)}}</label>
        </div>
        <div class="reportCard">
          <label class="labelHeader">PM Sold</label>
          <label class="value">$309K</label>
        </div>
        <div class="reportCard">
          <label class="labelHeader">$ to Goal</label>
          <label class="value">67.26%</label>
        </div>
        <spacer />
        <div class="ytdByStyle">
          <!-- <label class="labelHeader">YTD by Style</label> -->
          <!-- <canvas id="ytdStyleChart" style="width:100%;float:left;" /> -->
          <!-- <Chart v-if="config" :config="config" /> -->
          <vue-apex-charts height="350" style="width:100%;" type="treemap" :options="chartOptions" :series="ytdByStyle"></vue-apex-charts>
        </div>
      </div>
      <div class="twenty left">
        <!-- <label style="width:100%;float:left;text-align: center;">Stretch Sales Goal</label> -->
        <div class="reportCard">
          <label class="labelHeader">Stretch Sales goal</label>
          <!-- <label class="value"></label> -->
          <div style="width:100%;float:left;">
            <!-- <CProgress
              :value="809000"
              :max="1600000"
              color="success"
              striped
              class="mb-2"
            /> -->
            <vue-apex-charts style="width:100%;" type="radialBar" :options="stretchSalesGoalOptions" :series="stretchSalesGoal"></vue-apex-charts>
          </div>
          <!-- <label class="value">$809k</label> -->
        </div>
        <div class="reportCard small">
          <label class="labelHeader">% to Stretch Goal</label>
          <label class="value gold">{{stretchGoalPercentage}}%</label>
        </div>
        <div class="reportCard small">
          <label class="labelHeader">Stretch Sales Goal</label>
          <label class="value">${{getNumFormat(data.goals.stretch_goal_current)}}</label>
        </div>
        <div class="reportCard small">
          <label class="labelHeader">LY to Date</label>
          <label class="value">(Blank)</label>
        </div>
      </div>
      <div class="forty left">
        <label style="width:100%;float:left;text-align: center;">2023 Imperial Sales Rep Dashboard</label>
        <div class="half">
          <div class="reportCard">
            <label class="labelHeader">Apparel Goal</label>
            <!-- <label class="value"></label> -->
            <div style="width:100%;float:left;">
              <!-- <CProgress
                :value="96000"
                :max="110000"
                color="success"
                striped
                class="mb-2"
              /> -->

              <vue-apex-charts style="width:100%;" type="radialBar" :options="apparelGoalOptions" :series="apparelGoalSeries"></vue-apex-charts>
            </div>
            <!-- <label class="value">$96k</label> -->
          </div>
          <div class="reportCard small">
            <label class="labelHeader">% to Apparel Goal</label>
            <label class="value gold">87%</label>
          </div>
          <div class="reportCard small">
            <label class="labelHeader">Apparel Sales Goal</label>
            <label class="value">$110K</label>
          </div>
        </div>
        <div class="half">
          <div class="reportCard">
            <label class="labelHeader">Belt Goal</label>
            <!-- <label class="value"></label> -->
            <div style="width:100%;float:left;">
              <vue-apex-charts style="width:100%;" type="radialBar" :options="beltGoalOptions" :series="beltGoalSeries"></vue-apex-charts>
            </div>
            <!-- <label class="value">$23K</label> -->
          </div>
          <div class="reportCard small">
            <label class="labelHeader">% to Belt Goal</label>
            <label class="value gold">{{beltGoalPercentage}}%</label>
          </div>
          <div class="reportCard small">
            <label class="labelHeader">Belt Sales Goal</label>
            <label class="value">${{getNumFormat(data.goals.belt_goal_current)}}</label>
          </div>
        </div>
      </div>
      <div class="twenty left">
        <!-- <label style="width:100%;float:left;text-align: center;">Stretch Sales Goal</label> -->
        <div class="reportCard">
          <label class="labelHeader">Total Accounts Goal</label>
          <!-- <label class="value"></label> -->
          <div style="width:100%;float:left;">
            <vue-apex-charts style="width:100%;" type="radialBar" :options="totalAccountsOptions" :series="totalAccountsSeries"></vue-apex-charts>
          </div>
          <!-- <label class="value">94</label> -->
        </div>
        <div class="reportCard small">
          <label class="labelHeader">% to Accounts Goal</label>
          <label class="value gold">{{totalAccountsPercentage}}%</label>
        </div>
        <div class="reportCard small">
          <label class="labelHeader">Total Accounts Goal</label>
          <label class="value">{{data.goals.accounts_goal}}</label>
        </div>
        <div class="reportCard small">
          <label class="labelHeader">Territory Penetration</label>
          <label class="value">22.82%</label>
        </div>
      </div>
      <div class="sixty left">
        <spacer />
        <div class="lineChartSales">
          <!-- <CChartLine
            :datasets="defaultDatasets"
            labels="months"
          /> -->
          <vue-apex-charts type="area" height="200" :options="salesTrendsOptions" :series="salesTrendsSeries"></vue-apex-charts>
        </div>
        <div class="acctSalesVolume">
          <label class="labelHeader">Acct Sales Volume</label>
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>Accts > 30K</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Accts > 20K</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Accts > 10K</td>
                <td>9</td>
              </tr>
              <tr>
                <td>Accts > 5K</td>
                <td>29</td>
              </tr>
              <tr>
                <td>Accts > 2.5K</td>
                <td>14</td>
              </tr>
              <tr>
                <td>Accts > 1K</td>
                <td>18</td>
              </tr>
              <tr>
                <td>Accts < 1K</td>
                <td>16</td>
              </tr>
              <tr>
                <td>Total Accounts</td>
                <td>94</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="acctInfoTable">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Account Name</th>
                <th>YTD 2022</th>
                <th>YTD 2023</th>
                <th>CY - PY</th>
                <th>% Growth Decline</th>
                <th>% of YTD Sales</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>The Cramer Mountain Club</td>
                <td></td>
                <td>$0</td>
                <td>$0</td>
                <td>0.00</td>
                <td>0.00</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="twenty left">
        <div class="ytdByStyle">
          <label class="labelHeader">YTD by Style</label>
          <vue-apex-charts height="300" style="width:100%;" type="treemap" :options="chartOptions" :series="ytdByStyle"></vue-apex-charts>
        </div>
      </div>
    </div>
    <small-loader v-else-if="loading" />
  </div>
</template>
<script>
var methods = {}
import { CChartLine } from '@coreui/vue-chartjs'
// import { Chart, registerables, TooltipPositionerFunction } from 'chart.js';
// import {TreemapController, TreemapElement} from 'chartjs-chart-treemap';
import VueApexCharts from 'vue-apexcharts'

const circleChartOptions = {
  chart: {
    type: 'radialBar',
    offsetY: -20,
    sparkline: {
      enabled: true
    }
  },
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      track: {
        background: "#e7e7e7",
        strokeWidth: '97%',
        margin: 5, // margin is in pixels
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          color: '#999',
          opacity: 1,
          blur: 2
        },
      },
      dataLabels: {
        name: {
          show: false
        },
        value: {
          offsetY: -2,
          fontSize: '22px',
          formatter: function (val) {
            console.log('ooooo')
            console.log(val)
            return val.value + '%'
          }
        },
        total: {
          show: true,
          label: 'Goal',
          formatter: function(seriesName, opts) {
            return seriesName.config.labels[0]
          }
        }
      }
    }
  },
  colors: ['#aba003'],
  grid: {
    padding: {
      top: -10
    }
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'light',
      shadeIntensity: 0.4,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 50, 53, 91]
    },
  },
  labels: [''],
}

methods.getReps = function () {
  axios.get(this.$apiAdress + '/api/getAllReps?token=' + localStorage.getItem('api_token')).then(response => {    
    this.repOptions = response.data 
  }).catch(e => {    
  })
}

methods.getData = function () {
  this.loading = true
  const postData = {
    rep: this.accountSelected
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/reports/salesComReport?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data
    this.loading = false
  })
}

methods.getNumFormat = function (num) {
  var r = ''
  num = parseInt(num)
  if (num >= 1000000) {
    r = (num / 1000000).toFixed(1) + 'M'
  } else if (num >= 1000) {
    r = (num / 1000).toFixed(1) + 'K'
  } else {
    r = num.toString()
  }
  return r
}

export default {
  // ===Component name
  name: "RepReportingDash",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {
    CChartLine,
    VueApexCharts
    // Chart
  },
  // ====component Data properties
  data(){
      return{
        repOptions: null,
        accountSelected: null,
        config: null,
        loading: false,
        data: null,
        chartOptions: {
          legend: {
            show: false
          },
          chart: {
            // height: 300,
            type: 'treemap'
          },
          title: {
            text: 'YTD By Style'
          }
        }
      }
  },
  watch: {
    'accountSelected': function (newVal, oldVal) {
      this.data = null
      if (newVal) {
        this.getData()
      }
    }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getReps()
    // Chart.register(TreemapController, TreemapElement, registerables, TooltipPositionerFunction);

    this.config = {
      type: 'treemap',
      data: {
        datasets: [
          {
            label: 'My treemap dataset',
            tree: [15, 6, 6, 5, 4, 3, 2, 2],
            borderColor: 'green',
            borderWidth: 1,
            spacing: 0,
          }
        ],
      },
      // options: {
      //   plugins: {
      //     title: {
      //       display: true,
      //       text: 'My treemap chart'
      //     },
      //     legend: {
      //       display: false
      //     }
      //   }
      // }
    };

    // setTimeout(function () {
    //   const chart = new Chart(document.getElementById("ytdStyleChart"), config);
    // }, 2000);


  },
  // ===Computed properties for the component
  computed: {
    defaultDatasets () {
      return [
        {
          label: '2022 Sales',
          backgroundColor: 'rgb(228,102,81,0.9)',
          data: [30, 39, 10, 50, 30, 70, 35]
        },
        {
          label: '2023 Sales',
          backgroundColor: 'rgb(0,216,255,0.9)',
          data: [39, 80, 40, 35, 40, 20, 45]
        }
      ]
    },
    stretchSalesGoal() {
      if (this.data) {
        return [this.stretchGoalPercentage]
      } else {
        return [0]
      }
    },
    stretchGoalPercentage() {
      if (this.data) {
        var calc = parseFloat(parseFloat(this.data.sales_data.amount_sold) / parseFloat(this.data.goals.stretch_goal_current)) * 100

        return calc.toFixed(2)
      } else {
        return 0
      }
    },
    stretchSalesGoalOptions() {
      // var totalLabel = '809K'
      // const op = circleChartOptions
      var o = {}
      for (var key in circleChartOptions) {
        o[key] = circleChartOptions[key]
      }
      var num = this.getNumFormat(this.data.sales_data.amount_sold)
      o.labels = [num]
      return o
    },
    apparelGoalOptions() {
      // const op = circleChartOptions
      var o = {}
      for (var key in circleChartOptions) {
        o[key] = circleChartOptions[key]
      }
      o.labels = ['$96K']
      return o
    },
    apparelGoalSeries() {
      return [87]
    },
    beltGoalOptions() {
      var o = {}
      for (var key in circleChartOptions) {
        o[key] = circleChartOptions[key]
      }
      var num = this.getNumFormat(this.data.sales_data.belts_sold)
      o.labels = [num]
      return o
    },
    beltGoalPercentage() {
      if (this.data) {
        var calc = parseFloat(parseFloat(this.data.sales_data.belts_sold) / parseFloat(this.data.goals.belt_goal_current)) * 100

        return calc.toFixed(2)
      } else {
        return 0
      }
    },
    beltGoalSeries() {
      if (this.data) {
        var num = this.beltGoalPercentage
        return [parseInt(num)]
      } else {
        return [0]
      }
    },
    totalAccountsOptions() {
      var o = {}
      for (var key in circleChartOptions) {
        o[key] = circleChartOptions[key]
      }
      var num = this.getNumFormat(this.data.sales_data.account_count)
      o.labels = [num]
      return o
    },
    totalAccountsPercentage() {
      if (this.data) {
        var calc = parseFloat(parseFloat(this.data.sales_data.account_count) / parseFloat(this.data.goals.accounts_goal)) * 100

        return calc.toFixed(2)
      } else {
        return 0
      }
    },
    totalAccountsSeries() {
      if (this.data) {
        var num = this.totalAccountsPercentage
        return [parseInt(num)]
      } else {
        return [0]
      }
    },
    salesTrendsSeries() {
      return [{
        name: '2022',
        data: [31, 40, 28, 51, 42, 109, 100]
      }, {
        name: '2023',
        data: [11, 32, 45, 32, 34, 52, 41]
      }]
    },
    salesTrendsOptions() {
      return {
            chart: {
              height: 350,
              type: 'area'
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'smooth'
            },
            xaxis: {
              type: 'datetime',
              categories: ["2023-01-01", "2023-02-01", "2023-03-01", "2023-04-01", "2023-05-01", "2023-06-01", "2023-07-01"]
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm'
              },
            },
          }
    },
    ytdByStyle() {
      if (this.data && this.data.style_data.length) {
        var arr = [{
          data: []
        }]
        this.data.style_data.forEach(function (val) {
          var o = {
            x: val.ODSTY.trim(),
            y: val.total_sales
          }
          arr[0].data.push(o)
        })
        return arr
      } else {
        return [
              {
                data: [
                  {
                    x: 'X210P',
                    y: 6
                  },
                  {
                    x: '5054',
                    y: 2
                  },
                  {
                    x: '10105',
                    y: 1
                  },
                  {
                    x: '7054',
                    y: 1
                  },
                  {
                    x: 'IEX210P',
                    y: 1
                  },
                  {
                    x: 'L210P',
                    y: 1
                  }
                ]
              }
            ]
      }
    }
  },
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .twenty {
    width: 20%;
    float:left;
    padding: 2px;
  }

  .eighteen {
    width: 18%;
    float:left;
  }

  .forty {
    width: 40%;
    float:left;
    padding: 2px;
  }

  .half {
    width: 50%;
    float:left;
    padding:2px;
  }

  .sixty {
    width:60%;
    float:left;
    padding: 2px;
  }

  .lineChartSales {
    width: 75%;
    float:left;
  }

  .acctSalesVolume {
    width:25%;
    float:left;
  }

  .acctInfoTable {
    width: 100%;
    float:left;

    table {
      tr {
        th {
          font-size: .8em;
        }
        td {
          font-size:.8em;
        }
      }
    }
  }

  .labelHeader {
      width:100%;
      float:left;
      text-align:center;
      font-size:11px;
      font-weight:800;
    }

  .reportCard {
    width:100%;
    float:left;
    border: 1px solid black;
    margin-top: 5px;
    
    .value {
      width:100%;
      float:left;
      text-align:center;
      font-weight: 800;
      font-size:15px;
    }

    &.small {
      label {
        margin: 0 !important;
      }
    }
  }

  .table {
    tr {
      td {
        padding: 0px !important;
        padding-left:2px !important;
        border: 1px solid grey;
      }
    }
  }

  .gold {
    color: #aba003;
  }

  .ytdByStyle {
    width:100%;
    float:left;

    .labelHeader {
      width:100%;
      float:left;
      text-align:center;
      font-size:1.3em;
      font-weight:800;
    }
  }
</style>
